import { render } from "./LostPassword.vue?vue&type=template&id=28dc9507&scoped=true"
import script from "./LostPassword.vue?vue&type=script&lang=ts"
export * from "./LostPassword.vue?vue&type=script&lang=ts"

import "./LostPassword.vue?vue&type=style&index=0&id=28dc9507&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-28dc9507"

export default script